{
  "title": "Thaumaturgy",
  "source": "Player's Handbook",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V",
  "duration": "Up to 1 minute",
  "description": [
    "You manifest a minor wonder, a sign of supernatural power, within range. You create one of the following magical effects within range:",
    "Your voice booms up to three times as loud as normal for 1 minute.",
    "You cause flames to flicker, brighten, dim, or change color for 1 minute.",
    "You cause harmless tremors in the ground for 1 minute.",
    "You create an instantaneous sound that originates from a point of your choice within range, such as a rumble of thunder, the cry of a raven, or ominous whispers.",
    "You instantaneously cause an unlocked door or window to fly open or slam shut.",
    "You alter the appearance of your eyes for 1 minute.",
    "If you cast this spell multiple times, you can have up to three of its 1-minute effects active at a time, and you can dismiss such an effect as an action."
  ],
  "spellLists": ["cleric"]
}
